<script>
export default {
  props: {
    pics: {
      type: Array,
    },
    dialogFormVisiblePhoto: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imgUrl: null,
    };
  },

  methods: {
    handleClickTag: function (url) {
      this.imgUrl = url;
    },
  },
  watch: {
    pics: {
      handler(newVal, oldVal) {
        if(newVal.length>0){
          this.imgUrl = newVal[0];
        }
      },
      deep: true,
    },
  },
  render() {
    const { dialogFormVisiblePhoto, imgUrl, pics } = this;
    const { handleClickTag, quit } = this;
    return (
      <el-dialog
        title="照片"
        lock-scroll={false}
        show-close={false}
        visible={dialogFormVisiblePhoto}
        width="500px"
      >
        {pics.length > 0 ? (
          <el-form label-position="right">
            <div class="check-photo">
              <div class="chkimg" style="text-align:center;overflow:hidden;">
                <img
                  src={imgUrl}
                  alt
                  style="max-height:300px;max-width:540px;"
                />
              </div>
              <ul class="tab-img">
                {this.pics.map((item) => (
                  <li class="fl" onClick={() => handleClickTag(item)}>
                    <a href="javascript:;">
                      <img src={item} alt width="100%" height="100%" />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </el-form>
        ) : (
          <div class="no-pics">暂无图片</div>
        )}

        <div slot="footer" class="dialog-footer">
          <el-button type="primary" onClick={() => this.$emit("func")}>
            确 定
          </el-button>
        </div>
      </el-dialog>
    );
  },
};
</script>
<style>
.check-photo .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
.check-photo .tab-img {
  display: flex;
  justify-content: center;
}
.no-pics{
  text-align:center;
}
</style>